export default __webpack_public_path__ + "static/media/coplineLogo.a4130344.png";